/**
 * Sort posts on tag pages by published date (oldest to newest)
 */
(function() {
    'use strict';

    let isSorting = false;
    let hasSorted = false;
    let userInteracting = false;
    let lastInteractionTime = 0;

    // Track user interactions to prevent sorting during clicks
    document.addEventListener('mousedown', function() {
        userInteracting = true;
        lastInteractionTime = Date.now();
        setTimeout(function() {
            if (Date.now() - lastInteractionTime > 500) {
                userInteracting = false;
            }
        }, 500);
    });

    document.addEventListener('click', function() {
        userInteracting = true;
        lastInteractionTime = Date.now();
        setTimeout(function() {
            if (Date.now() - lastInteractionTime > 500) {
                userInteracting = false;
            }
        }, 500);
    });

    function sortPostsByDate() {
        // Don't sort if user is interacting or if already sorting
        if (isSorting || userInteracting) {
            return;
        }

        // Find the post feed container
        const postFeed = document.querySelector('.post-feed');
        if (!postFeed) {
            return;
        }

        // Get all post cards
        const allCards = Array.from(postFeed.querySelectorAll('.post-card'));
        
        // Separate header card (post-card-large) from regular post cards
        const headerCard = allCards.find(card => card.classList.contains('post-card-large'));
        const postCards = allCards.filter(card => !card.classList.contains('post-card-large'));
        
        // If there are no posts or only one, no need to sort
        if (postCards.length <= 1) {
            return;
        }

        // Check if posts are already sorted (oldest first)
        let isAlreadySorted = true;
        for (let i = 0; i < postCards.length - 1; i++) {
            const dateA = postCards[i].getAttribute('data-published-date');
            const dateB = postCards[i + 1].getAttribute('data-published-date');
            if (dateA && dateB && new Date(dateA) > new Date(dateB)) {
                isAlreadySorted = false;
                break;
            }
        }

        // If already sorted and we've sorted once, don't sort again
        if (isAlreadySorted && hasSorted) {
            return;
        }

        isSorting = true;

        // Sort posts by published date (oldest first)
        const sortedCards = postCards.slice().sort(function(a, b) {
            const dateA = a.getAttribute('data-published-date');
            const dateB = b.getAttribute('data-published-date');
            
            if (!dateA || !dateB) {
                return 0; // Keep original order if date is missing
            }
            
            return new Date(dateA) - new Date(dateB);
        });

        // Only reorder if order actually changed
        let orderChanged = false;
        for (let i = 0; i < postCards.length; i++) {
            if (postCards[i] !== sortedCards[i]) {
                orderChanged = true;
                break;
            }
        }

        if (orderChanged) {
            // Move nodes to correct position using insertBefore
            // insertBefore automatically moves nodes if they're already in the DOM (preserves event handlers)
            // Build the correct order: header first (if exists), then sorted posts
            const correctOrder = [];
            if (headerCard) {
                correctOrder.push(headerCard);
            }
            correctOrder.push.apply(correctOrder, sortedCards);
            
            // Work backwards to avoid position conflicts when moving nodes
            for (let i = correctOrder.length - 1; i >= 0; i--) {
                const node = correctOrder[i];
                if (node.parentNode === postFeed) {
                    // Find what should come after this node
                    const nextSibling = i < correctOrder.length - 1 ? correctOrder[i + 1] : null;
                    
                    // If node is not already followed by its correct next sibling, move it
                    if (nextSibling) {
                        if (node.nextSibling !== nextSibling) {
                            postFeed.insertBefore(node, nextSibling);
                        }
                    } else {
                        // This is the last node, append it if not already last
                        if (postFeed.lastChild !== node) {
                            postFeed.appendChild(node);
                        }
                    }
                }
            }
        }

        hasSorted = true;
        isSorting = false;
    }

    // Run on page load with a delay to ensure DOM is fully ready
    function initSort() {
        setTimeout(function() {
            if (!userInteracting) {
                sortPostsByDate();
            }
        }, 100);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSort);
    } else {
        initSort();
    }

    // Also run after infinite scroll loads new content
    // But only if user is not interacting
    let sortTimeout;
    const observer = new MutationObserver(function(mutations) {
        // Don't sort if user is interacting
        if (userInteracting || isSorting) {
            return;
        }

        let shouldSort = false;
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                // Check if any added nodes are post cards
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && (node.classList && node.classList.contains('post-card'))) {
                        shouldSort = true;
                    }
                });
            }
        });
        
        if (shouldSort) {
            // Clear any pending sort
            clearTimeout(sortTimeout);
            // Debounce: wait to ensure all posts are loaded and user isn't clicking
            sortTimeout = setTimeout(function() {
                if (!isSorting && !userInteracting) {
                    hasSorted = false; // Reset flag so new posts get sorted
                    sortPostsByDate();
                }
            }, 500);
        }
    });

    // Start observing the post feed for changes
    const postFeed = document.querySelector('.post-feed');
    if (postFeed) {
        observer.observe(postFeed, {
            childList: true,
            subtree: false
        });
    }

})();

